import React from "react";
import ApartmentDetailsView from "../../../../views/dashboard/apartments/Details";

const ApartmentDetails = () => {
  return <ApartmentDetailsView />;
};

export default ApartmentDetails;
